export default {
    ir_isolated_heat_source: {
        name: "IR Isolated Heat Source",
        url: "nwcg_ir/ir_isolated_heat_source",
    },
    possible_ir_heat_source: {
        name: "Possible IR Heat Source",
        url: "nwcg_ir/possible_ir_heat_source",
    },
}
